import { Fragment, useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import {Link} from 'react-router-dom';
import API from '../../../../config/API';
import Loading from '../../../theme/loading';

const ListConfiguration = () => {

  const [state, setState] = useState({ status : "loading", configlist: [], search: "" })


  useEffect(()=>{
    API.get('/v3/api/utils/configurations', {}).then((data)=>{
        setState({status:"loaded", configlist:data, search:""});
    });
  },[]);

  const filtersConfiguration = () => {

    return state.configlist.filter((e)=>{

      return ((e._id+e.name).indexOf(state.search) !== -1?true:false);

    });

  }

  const columns = [
    { name: 'ID', selector: (row) => (<Link to={"/app/configuration/edit/"+row._id}>{row._id}</Link>), },
    { name: 'Actions', selector: (row) => (<Fragment><Link to={"/app/configuration/edit/"+row._id}>Edit configuration</Link></Fragment>), }
  ];

  if(state.status === "loading"){ return <Loading /> }

  return(
    <div>
      <h2>Configuration list</h2>
      
      <div className="row mt-3 mb-3">
        <div className="col-md-9">
          <input type="text" className="form-control" onChange={(e)=>{ setState({...state, search: e.target.value})}} placeholder="Search..." />
        </div>
        <div className="col-md-3">
          <Link to="/app/configuration/add"><button className="btn btn-success form-control">Add Config</button></Link>
        </div>
      </div>

      {(state.status==='error'&&<div className="alert alert-danger">{state.message}</div>)}

      {(state.status==='loaded'&&<DataTable
            columns={columns}
            data={filtersConfiguration(state.configlist)}
        />)}


    </div>
  )
};

export default ListConfiguration;